module.exports = __webpack_public_path__ + "media/images/address/waze-d7bc45f5891186da36527feeb37b4864.svg";